import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ContractManagementEffects } from './store/contract-management.effects';
import { ChargeNumberManagementEffects } from './store/charge-number-management.effects';
import { StoreModule } from '@ngrx/store';
import * as fromContractMgmt from './store/contract-management.reducer';
import * as fromCNMgmt from './store/charge-number-management.reducer';
import * as fromFM from './store/funding-mod.reducer';
import * as fromIC from './store/invoice-cycle.reducer';
import { FundingModEffects } from './store/funding-mod.effects';
import { InvoiceCycleEffects } from './store/invoice-cycle.effects';
import { ContractManagementPresentersComponent } from './presenters/contract-management-presenters.component';
import { ContractManagementFeaturesComponent } from './features/contract-management-features.component';
import { SharedModule } from '../shared/shared.module';
import { MessageModule } from '../shared/efaact-primeng.module';

@NgModule({
  declarations: [ ContractManagementPresentersComponent, ContractManagementFeaturesComponent],
  imports: [
    CommonModule,
    SharedModule,
    MessageModule,
    StoreModule.forFeature(
      fromContractMgmt.contractManagementsFeatureKey,
      fromContractMgmt.reducer
    ),
    StoreModule.forFeature(
      fromCNMgmt.chargeNumberManagementsFeatureKey,
      fromCNMgmt.reducer
    ),
    StoreModule.forFeature(
      fromFM.fundingModsFeatureKey,
      fromFM.reducer
    ),
    StoreModule.forFeature(
      fromIC.invoiceCyclesFeatureKey,
      fromIC.reducer
    ),
    EffectsModule.forFeature([ContractManagementEffects, ChargeNumberManagementEffects, FundingModEffects, InvoiceCycleEffects])
  ]
})
export class ContractManagementModule {}
